export class LabeledText {
  public label: string;
  public text: string;

  constructor(label: string, text: string) {
    this.label = label;
    this.text = text;
  }
}

export class NamedValue {
  private _id: string;
  private _name: string;

  constructor(id: string, name: string) {
    this._id = id;
    this._name = name;
  }

  get id(): string {
    return this._id;
  }

  get name(): string {
    return this._name;
  }

  public toString(): string {
    return `${this._name} (${this._id})`;
  }
}

export class PagingOptions {
  public pageSize: number;
  public datetime?: string;

  constructor(pageSize: number, datetime?: string) {
    this.pageSize = pageSize;
    this.datetime = datetime;
  }
}

export enum ReferralType {
  ESPOED = "ESpoed",
  TRIAGE = "Triage",
  SELFREFERRER = "SelfReferrer",
}

export interface IReferral {
  urn: string;
  reference?: string;
  status: string;
  state: string;
  type: string;
}

export enum UrgencyCode {
  A1 = "A1",
  A2 = "A2",
  B1 = "B1",
  B2 = "B2",
  U0 = "U0",
  U1 = "U1",
  U2 = "U2",
  U3 = "U3",
  U4 = "U4",
  U5 = "U5",
  H1 = "H1",
  UNKNOWN = "UNKNOWN",
}

export class GenericReferral implements IReferral {
  public urn: string;
  public reference?: string;
  public status: string;
  public state: string;
  public type: ReferralType;
  public urgencyCode: UrgencyCode;
  public patientName: string;
  public patientNumber?: string;
  public patientNumberVerificationLink?: string;
  public patientNumberStatusMessage?: string;
  public patientBirthDate?: Date;
  public gender?: string;
  public messageDateTime?: Date;
  public messageDate?: string;
  public messageTime?: string;
  public etaDate?: string;
  public etaTime?: string;
  public ambulanceId?: string;
  public departureLocation?: string;
  public sendingEntity?: string;
  public clusterCode?: string;
  public departmentCode?: string;
  public departmentName?: string;
  public requiredSpecialism?: string;
  public injury?: string;
  public isCancelled: boolean;
  public isDeprecatedVersion: boolean;
  public isSelected: boolean = false;
  public hasAmbulanceFeedback: boolean = false;
  public isOpened: boolean = false;

  private _isHighlighted: boolean;

  constructor(
    urn: string,
    status: string,
    state: string,
    urgencyCode: string,
    patientName: string,
    patientBirthDate: Date | undefined,
    hasAmbulanceFeedback: boolean,
    reference?: string,
  ) {
    var fixedUrgencyCode: string = urgencyCode == "1" ? "H1" : urgencyCode;
    this.type = ReferralType.ESPOED;
    this.urn = urn;
    this.status = status;
    this.state = state;
    this.urgencyCode = (fixedUrgencyCode as UrgencyCode) || UrgencyCode.UNKNOWN;
    this.reference = reference;
    this.patientName = patientName;
    this.patientBirthDate = patientBirthDate;

    this._isHighlighted = false;
    this.isCancelled = false;
    this.isDeprecatedVersion = false;
    this.hasAmbulanceFeedback = hasAmbulanceFeedback;
  }

  get isHighlighted(): boolean {
    return this._isHighlighted;
  }

  set isHighlighted(value: boolean) {
    this._isHighlighted = value;
    if (value) {
      const instance: GenericReferral = this;
      setTimeout(() => {
        instance._isHighlighted = false;
      }, 10000);
    }
  }
}

export enum SignalREvents {
  Connected = "connected",
  Disconnected = "disconnected",
  AddReferral = "addReferral",
  UpdatePatientNumber = "updatePatientNumber",
  ManualReferralClose = "manualReferralClose",
  ReferralOpened = "referralOpened",
  UpdateEtaTime = "updateEtaTime",
}
